import { connect } from 'react-redux';

import ForgotPasswordRoute from 'components/login/ForgotPasswordRoute';

export default connect((state) => ({
  authenticated: state.user.authenticated,
}))(ForgotPasswordRoute);
